import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    '& .react-multi-carousel-item': {
      paddingRight: theme.spacing(2),
    },

    'swiper-slide': {
      width: theme.spacing(35.5),
      marginRight: theme.spacing(2),
    },
  },

  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  headerActions: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },

  headerButtons: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: theme.spacing(50),
  },

  divider: {
    marginBottom: theme.spacing(2),
  },

  arrows: {
    display: 'flex',
    minWidth: theme.spacing(5.25),
    paddingLeft: theme.spacing(2),
  },

  arrow: {
    color: theme.palette.action.active,
    cursor: 'pointer',

    '&:hover': {
      color: theme.palette.primary.light,
    },
  },
}));
